import { render, staticRenderFns } from "./KillNewModal.vue?vue&type=template&id=6a9b89c1"
import script from "./KillNewModal.vue?vue&type=script&lang=js"
export * from "./KillNewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports